import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, AbstractControl, FormControl, Validators } from '@angular/forms'; 
import { tenant } from './../../../models/admin';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { UtilityService } from './../../../services/utility.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { quater, year} from './../../../models/slakpi';
import Swal from 'sweetalert2'
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
import { RSAHelper } from '../../../models/RSAHelper';

@Component({
  selector: 'app-tenant',
  templateUrl: './tenant.component.html',
  styleUrls: ['./tenant.component.css']
})
export class TenantComponent implements OnInit {
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  searchText: string;
  dataSearch: any;
  modalRef: BsModalRef;
  @ViewChild('editSettingsTemplate', { static: false }) editTemplate: TemplateRef<any>;
  public title: string = 'Add';
  public data: any;
  public tenant_data: any;
  public user_data: any;
  public editSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public orderData: object;
  public tenantData: object[];
  public tenantForm: FormGroup;
  public submitClicked: boolean = false;
  public pageAction: string = 'add';
  public permission: number = 1;
  public isClicked: boolean = false;
  public yearData: any;
  public quaterData: any;
  public currentHalfData: any;
  public currentMonthData: any;
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  isEditOnly: boolean = false;
  tenantUno: number;
  constructor(public restApi: AdminApiService, public restApi1: SLAKPIApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public RASHelper: RSAHelper) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.isEditOnly = (this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'BM Administrator') ? true : false;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin && !this.isEditOnly) {
      this.router.navigateByUrl('/access-denied');
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.tenantUno = this.user.tenantUno;
    //this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };

    this.loadTenant();    
    this.loadYear();
    this.loadQuater();
    this.getYearHalfData();
    this.getMonthData();
    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };
    
    if (this.permission == 1) {
      this.toolbar = ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search'];
    }
    else
      this.toolbar = ['Search'];
    
    this.pageSettings = { pageCount: 5 };
   // this.tenantData = DataUtil.distinct(this.data, 'id', true);
   
    
  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'tenantUno', name: 'Tenant Code', field: 'tenantUno', sortable: true, maxWidth: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'tenantUno', 'tenantUno'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'tenantNameEn', name: 'Tenant  [English]', field: 'tenantNameEn', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'tenantNameEn', 'tenantNameEn'),
          model: Filters.multipleSelect,
        }
      },
    
      {
        id: 'tenantNameAr', name: 'Tenant  [Arabic]', field: 'tenantNameAr', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'tenantNameAr', 'tenantNameAr'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', maxWidth: 75,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'edit_row', positionOrder: 62, title: 'Edit',

              iconCssClass: 'fa fa-edit fa-lg ', cssClass: 'green-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1)
                  return true;
                else false;
              },
              action: (e, args) => {
                this.editItem(args.dataContext);
              }
            },
            

          
            {
              command: 'delete-row', titleKey: 'del_row', positionOrder: 65, title: 'Delete',
              iconCssClass: 'fa fa-trash fa-lg ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1 && this.isAdmin)
                  return true;
                else false;
              },
              action: (e, args) => {
                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteTenant(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })

              }
            },


          ],
        }
      }

    ]


  }


  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (this.permission == 1 )
      return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
    else
      return '';
  };



  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  // Get tenant list
  loadTenant() {
    this.spinner.show();
    let inpValue = new tenant();    
    inpValue.languageUno = 1033;
    inpValue.itemUno = (this.isAdmin) ? 0 : this.tenantUno;
    inpValue.condition = (this.isAdmin)? 1: 2;
    inpValue.userUno = this.login_UserID;
    
    
    this.restApi.getTenants(inpValue)
      .subscribe(data => {
        
        this.data = data;
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            tenantUno: this.data[i].tenantUno,
            tenantNameEn: this.data[i].tenantNameEn,
            tenantNameAr: this.data[i].tenantNameAr,
            currentYear: this.data[i].currentYear,
            currentHalf: this.data[i].currentHalf,
            currentQuarter: this.data[i].currentQuarter,
            currentMonth: this.data[i].currentMonth,
            wellPerformKPIRange: this.data[i].wellPerformKPIRange,
            fromEmail: this.data[i].fromEmail,

            slaName: this.data[i].slaName,
            siteHeading: this.data[i].siteHeading,
            isDigitalDewa: this.data[i].isDigitalDewa,
            isDynamicEntry: this.data[i].isDynamicEntry,
            isEnableNotification: this.data[i].isEnableNotification
           
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      }); 
  }
   
  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getYearMasterTenant(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    
    this.restApi1.getQuaterMaster(inpValue)
      .subscribe(data => {
        
        this.quaterData = data;
       

      },
        (error) => { 
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getYearHalfData() {
    this.currentHalfData = [
      { value: 1, displayText: 'First Half' },
      { value: 2, displayText: 'Second Half' }
    ];
  }

  getMonthData() {
    this.currentMonthData = [
      { value: 1, displayText: 'M1' },
      { value: 2, displayText: 'M2' },
      { value: 3, displayText: 'M3' },
      { value: 4, displayText: 'M4' },
      { value: 5, displayText: 'M5' },
      { value: 6, displayText: 'M6' },
      { value: 7, displayText: 'M7' },
      { value: 8, displayText: 'M8' },
      { value: 9, displayText: 'M9' },
      { value: 10, displayText: 'M10' },
      { value: 11, displayText: 'M11' },
      { value: 12, displayText: 'M12' }
    ];
  }
  addNewYear() {
    this.isClicked = true;
    let objTenant = new tenant();
    objTenant.tenantUno = this.tenantUno
    objTenant.userUno = this.login_UserID;
    
    this.spinner.show();
    this.restApi.addYear(objTenant)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          this.toaster.show('success', 'Success', 'Year added.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Year added.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})

          this.loadYear();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
  createFormGroup(data1: any): FormGroup {
    
    return new FormGroup({
      tenantUno: new FormControl(data1.tenantUno),
      tenantNameEn: new FormControl(data1.tenantNameEn, Validators.required),
      tenantNameAr: new FormControl(data1.tenantNameAr, Validators.required),
      currentYear: new FormControl(data1.currentYear),
      currentHalf: new FormControl(data1.currentHalf),
      currentQuarter: new FormControl(data1.currentQuarter),
      currentMonth: new FormControl(data1.currentMonth),
      wellPerformKPIRange: new FormControl(data1.wellPerformKPIRange),
      fromEmail: new FormControl(data1.fromEmail, Validators.email),
      slaName: new FormControl(data1.slaName),
      siteHeading: new FormControl(data1.siteHeading),
      isDigitalDewa: new FormControl(data1.isDigitalDewa),
      isDynamicEntry: new FormControl(data1.isDynamicEntry),
      isEnableNotification: new FormControl(data1.isEnableNotification)
    });
  }
  addItem() {
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.pageAction = "add";
    this.submitClicked = false;
    
    this.title = 'Add Tenant';
    this.tenantForm = new FormGroup({
      tenantUno: new FormControl(0),
      tenantNameEn: new FormControl(null, Validators.required),
      tenantNameAr: new FormControl(null, Validators.required),
      currentYear: new FormControl(null),
      currentHalf: new FormControl(null),
      currentQuarter: new FormControl(null),
      currentMonth: new FormControl(null),
      wellPerformKPIRange: new FormControl(null),
      fromEmail: new FormControl(null, Validators.email),
      slaName: new FormControl(null),
      siteHeading: new FormControl(null),
      isDigitalDewa: new FormControl(null),
      isDynamicEntry: new FormControl(null),
      isEnableNotification: new FormControl(null)
    });
  }

  editItem(data) {
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.pageAction = "edit";
    this.submitClicked = false;
    this.title = 'Details of ' + data.tenantNameEn;
    this.tenantUno = data.tenantUno;
    this.tenantForm = this.createFormGroup(data)
  }
  saveTenant(): void {
    this.submitClicked = true;
    if (this.tenantForm.valid) {
      let data = this.tenantForm.value;
      this.AddEditTenant(data);
    }
    else {
      //Swal.fire('Error', 'Enter the required values', 'error')
      this.toaster.show('error', 'Error', 'Enter the required values.');
    }
  }
 

  AddEditTenant(data1: any) {
    
    
    let objTenant = new tenant();
    objTenant.actionType = this.pageAction;
    objTenant.tenantUno = (this.pageAction == "add") ? 0 : data1.tenantUno;
    objTenant.tenantNameEn = this.utilityService.isStringNull(data1.tenantNameEn);
    objTenant.tenantNameAr = this.utilityService.isStringNull(data1.tenantNameAr);
    objTenant.currentYear = this.utilityService.isNumericNull(data1.currentYear);
    objTenant.currentHalf = this.utilityService.isNumericNull(data1.currentHalf);
    objTenant.currentQuarter = this.utilityService.isNumericNull(data1.currentQuarter);
    objTenant.currentMonth = this.utilityService.isNumericNull(data1.currentMonth);
    objTenant.wellPerformKPIRange = this.utilityService.isNumericNull(data1.wellPerformKPIRange);
    objTenant.fromEmail = this.utilityService.isStringNull(data1.fromEmail);
    
    objTenant.slaName = (this.utilityService.isStringNull(data1.slaName) != "") ? this.utilityService.isStringNull(data1.slaName) :"SLA";
    objTenant.siteHeading = (this.utilityService.isStringNull(data1.siteHeading) != "") ? this.utilityService.isStringNull(data1.siteHeading) :"Musherat";
    objTenant.isDigitalDewa =  this.utilityService.isNumericNull(data1.isDigitalDewa)
    objTenant.isDynamicEntry = this.utilityService.isNumericNull(data1.isDynamicEntry);
    objTenant.isEnableNotification = this.utilityService.isNumericNull(data1.isEnableNotification);

    objTenant.userUno = this.login_UserID;
    
    
    this.restApi.addEditTenant(objTenant)
      .subscribe(data => {
        
        this.submitClicked = false;
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          this.toaster.show('success', 'Success', 'Tenant saved.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Tenant saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.modalRef.hide();
          this.loadTenant();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  DeleteTenant(data1: any) {

    let objTenant = new tenant();
    objTenant.actionType = this.pageAction;
    objTenant.tenantUno = data1.tenantUno;
    objTenant.userUno = this.login_UserID;
    
    
    this.restApi.deleteTenant(objTenant)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
        //  Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          this.toaster.show('success', 'Success', 'Tenant deleted.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Tenant deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadTenant();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  onchangeYear(e) {
    
    
  }
  onchangeCurrentHalf(e) {
    
  }
  onchangeQuarter(e) {

  }
  onchangeCurrentMonth(e) {

  }
  //public onFilteringYear: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['displayText', 'value']);
  //  query = (e.text !== '') ? query.where('displayText', 'startswith', e.text, true) : query;
  //  e.updateData(this.yearData, query);
  //};
  //public onFilteringQuater: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['displayText', 'value']);
  //  query = (e.text !== '') ? query.where('displayText', 'startswith', e.text, true) : query;
  //  e.updateData(this.quaterData, query);
  //};
  //public onFilteringCurrentHalf: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['displayText', 'value']);
  //  query = (e.text !== '') ? query.where('displayText', 'startswith', e.text, true) : query;
  //  e.updateData(this.currentHalfData, query);
  //};
  //public onFilteringCurrentMonth: any = (e: FilteringEventArgs) => {
  //  // take text for highlight the character in list items.   
  //  let query: Query = new Query().select(['displayText', 'value']);
  //  query = (e.text !== '') ? query.where('displayText', 'startswith', e.text, true) : query;
  //  e.updateData(this.currentMonthData, query);
  //};
  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }
  //toolbarClick(args: ClickEventArgs): void {
  //  if (args.item.id === 'Grid_pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
  //    this.grid.pdfExport();
  //  }
  //}
  get tenantNameEn(): AbstractControl { return this.tenantForm.get('tenantNameEn'); }

  get tenantNameAr(): AbstractControl { return this.tenantForm.get('tenantNameAr'); }
  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.tenantNameEn && a.tenantNameEn.toLowerCase().includes(this.searchText.toLowerCase())
        );
    }
    else
      this.dataset = this.dataSearch;
  }
}
